export function validateVector(v, length) {
  if (v.length !== length) {
    return false;
  }

  return v.every(Number.isFinite);
}
//# sourceMappingURL=validators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deck.gl/core/node_modules/viewport-mercator-project/node_modules/math.gl/dist/esm/lib/validators.js
// module id = 282
// module chunks = 0